export default "__VITE_ASSET__CYMCviuE__$_?nuxt_component=async&nuxt_component_name=SvgoMeki&nuxt_component_export=default__"